<!--
 * @Description: 忘记密码， 这是个响应式的页面
 * @Autor: lwq
 * @Date: 2020-08-17 17:30:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-29 10:32:12
 * @FilePath: \mrc-ess-base-frontend\src\views\forget-password\index.vue
-->
<template>
  <div class="forget-password">
    <!-- 背景 -->
    <mrc_ess_svgIcon iconClass="left" class="left_bg"
      :style="{ left: -bgstyle / 2 + 'px', width: bgstyle + 'px', height: bgstyle + 'px' }" />
    <mrc_ess_svgIcon iconClass="right" class="right_bg"
      :style="{ right: -bgstyle / 2 + 'px', width: bgstyle + 'px', height: bgstyle + 'px' }" />
    <!-- webPc 的页面 -->
    <div class="webPc" v-if="webPc">
      <!-- 发送邮件 -->
      <v-card class="webSendMail" elevation="24" v-if="sendMail">
        <div class="forgot_title text-h3">{{ $t(title) }}</div>
        <mrc_ess_input :label="$t('label_Company_account')" background-color="#fff" style="margin-top: 40px"
          @keyupEnter="sendEmailHandler" @input="$v.sendEmailParams.user_account.$touch()"
          @blur="$v.sendEmailParams.user_account.$touch()" v-model.trim="sendEmailParams.user_account" :error-messages="
            $errors('sendEmailParams', 'user_account', requiredRule)
          ">
        </mrc_ess_input>

        <mrc_ess_submitBtn backgroundColor="#fff" class="mt-6" :loading="loading" @success="sendEmailHandler"
          @cancel="backHandler"></mrc_ess_submitBtn>
      </v-card>
    </div>

    <!-- 这是手机的输入框 -->
    <div class="phoneH5" v-else>
      <v-card v-if="sendMail" elevation="24" class="sendMail">
        <div class="forgot_title">{{ $t(title) }}</div>
        <mrc_ess_input :label="$t('label_Company_account')" background-color="#fff" style="margin-top: 32px"
          @keyupEnter="sendEmailHandler" @input="$v.sendEmailParams.user_account.$touch()"
          @blur="$v.sendEmailParams.user_account.$touch()" v-model.trim="sendEmailParams.user_account" :error-messages="
            $errors('sendEmailParams', 'user_account', requiredRule)
          "></mrc_ess_input>
        <mrc_ess_submitBtn backgroundColor="#fff" :loading="loading" class="phoneSubmitBtn mt-6"
          @success="sendEmailHandler" @cancel="backHandler"></mrc_ess_submitBtn>
      </v-card>
    </div>
    <!-- 这是页面底部的版本信息 -->
    <div class="bottom">
      <p>
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved
        <a href="https://privacy.essencehr.io/" target="_blank" class="hover1"
          style="color:#ffffff;text-decoration: none;caret-color: #fff!important;">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/" target="_blank" class="hover2"
          style="color:#ffffff;text-decoration: none;caret-color: #fff!important;">Term of Use.</a>
      </p>
    </div>
    <!-- 这是发送后的提示弹窗 -->
    <forgotConfirm v-model="openDialog" :msg="msg" @success="backToLogin" :email="email" :loading="loading"
      @cancel="resendEmail">
    </forgotConfirm>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import forgotConfirm from "./module/confirm"
import {
  savePwd,
  sendEmail,
  checkToken,
  passwordStrength,
} from "@/service/api/forgot-password"
export default {
  components: { forgotConfirm },
  props: {},
  data() {
    return {
      login_url: "",
      regxMsg: "",
      regxRule: "",
      disabled: false,
      successBackgroundColor: "primary",
      urlParams: {},
      title: "label_Retrieve_password",
      icon: "mdi-eye-off",
      type: "password",
      sendMail: false,

      sendEmailParams: {
        user_account: "",
      },
      savePwdParams: {
        user_account: "",
        user_pwd: "",
        sameAsPassword: "",
        token: "",
      },
      openDialog: false,
      is_showPassword: false,
      screenSize: "",
      // 是web的尺寸 true  手机的尺寸 false
      webPc: true,
      loading: false,
      email: "",
      msg: "",
    }
  },
  validations: {
    sendEmailParams: {
      user_account: {
        required,
      },
    },
    savePwdParams: {
      user_pwd: {
        required,
        isChina(val) {
          return this.isChina(val)
        },
        passwordStrengthRegxRule(val) {
          return new RegExp(this.regxRule).test(val)
        },
      },
      sameAsPassword: {
        required,
        sameAsPassword(val) {
          return val && val == this.savePwdParams.user_pwd
        },
      },
    },
  },
  computed: {
    bgstyle() {
      let size = 0;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = 0;
          break;
        case "sm":
          size = 600;
          break;
        case "md":
          size = 900;

          break;
        case "lg":
          size = 1000;

        case "xl":
          size = 1200;

          break;
        default:
          break;
      }
      return size;
    },
  },
  async created() {
    this.login_url = new URLSearchParams(
      window.location.href.slice(window.location.href.indexOf("?"))
    ).get("login_url")
    this.sendMail = true
    // this.title = 'Forgot Password'
    const that = this
    that.screenSize = document.documentElement.clientWidth
    if (that.screenSize > 750) {
      that.webPc = true
    } else {
      that.webPc = false
    }
    this.resize(function () {
      that.screenSize = document.documentElement.clientWidth
      if (that.screenSize > 750) {
        that.webPc = true
      } else {
        that.webPc = false
      }
    })
  },
  watch: {},
  mounted() { },

  methods: {
    // 发送邮件
    async sendEmailHandler() {
      this.$v.sendEmailParams.$touch()
      if (this.$v.sendEmailParams.$error) return
      this.loading = true

      const login_url = encodeURIComponent(this.login_url)
        ? encodeURIComponent(this.login_url)
        : ""
      const pubk = await this.$store.dispatch("setPubk")
      const res = await sendEmail({
        // user_account: this.sendEmailParams.user_account,
        user_account: this.$encrypt({
          msg: this.sendEmailParams.user_account,
          key: pubk,
        }),
        login_url: login_url,
        url: window.location.host,
      })

      this.loading = false
      if (res.code == 200) {
        this.email = res.data;
        this.msg = res.msg;
        this.openDialog = true
      }
    },
    // back
    backHandler() {
      if (this.login_url) {
        window.location.href = this.login_url
      } else {
      }
    },

    // 回到登录页
    backToLogin() {
      if (this.login_url) {
        window.location.href = this.login_url
      } else {
      }
    },
    async resendEmail() {
      await this.sendEmailHandler()
    },
    resize(fn) {
      window.addEventListener("resize", function () {
        fn()
      })
    },
  },
}
</script>

<style scoped>
@import '../login/bgd.css';

.forget-password {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: url("../../assets/img/loginBg.png") no-repeat; */
  text-align: center;
  background-color: #0f46c1;
}

.webResetPassword,
.webSendMail {
  width: 480px;
  height: 265px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 72px;
}

.webSendMail {
  height: 265px;
}

.webPc .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}

.forget-password /deep/ .btnGroup {
  justify-content: flex-end;
  /* height: 48px; */
  height: 32px;
}

.forget-password /deep/ .successBtn {
  /* width: 170px;
  height: 48px; */
  height: 32px;
  max-height: 48px !important;
  margin-left: 14px;
}

.forget-password /deep/ .cencelBtn {
  font-weight: medium;
  margin-right: 0;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  /* height: 347px; */
  height: 265px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
  width: 343px;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  min-width: 300px;
}

.phoneH5 .resetPassword {
  /* height: 500px; */
  height: 265px;
}

.phoneH5 .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}

.phoneH5 .phoneSubmitBtn /deep/ .successBtn {
  margin: 20px 0;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 5px;
  text-align: center;
  left: 50%;
  z-index: 10;
  color: rgba(255, 255, 255, 0.68);
  transform: translateX(-50%);
  font-family: var(--body-font-family) !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 128.91% !important;
}

.bottom p {
  letter-spacing: 1px;
  margin: 0;
}

/* @-webkit-keyframes bgd_rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes bgd_rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.bgd_left_box {
  transform: translate(-42%, 20%);
}
.bgd_right_box {
  transform: translate(40%, -57%);
}
.bgd_left_box_img {
  width: calc(64rem * 2);
  height: calc(68rem * 2);
  animation: bgd_rotate 20s ease-in-out infinite;
}
.bgd_right_box_img {
  width: calc(58rem * 4);
  height: calc(68rem * 4);
  animation: bgd_rotate 20s ease-in-out infinite;
}
@media screen and (max-width: 2000px) {
  .bgd_left_box {
    transform: translate(-42%, 20%);
  }
  .bgd_right_box {
    transform: translate(54%, -53%);
  }
  .bgd_left_box_img {
    width: calc(64rem);
    height: calc(68rem);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box_img {
    width: calc(58rem * 2);
    height: calc(68rem * 2);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 1400px) {
  .bgd_left_box {
    transform: translate(-55%, 16%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.9);
    height: calc(68rem * 0.9);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(54%, -32%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 992px) {
  .bgd_left_box {
    transform: translate(-68%, 22%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.8);
    height: calc(68rem * 0.8);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(46%, -31%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}
@media screen and (max-width: 800px) {
  .bgd_left_box {
    display: none;
  }
  .bgd_right_box {
    display: none;
  }
} */
</style>
